import React from "react"
import styles from './AppInput.module.css'

export const AppInput = ({ register, field, type, placeholder, value }) => {
    return <input
        className={styles.search__input}
        {...register(field)}
        type={type}
        placeholder={placeholder}
        autoFocus
        required
        defaultValue={value}
    />

}